@if (status === 'success') {
<div class="flex flex-col items-center justify-center  bg-gray-50 p-4">
  <div class="bg-white rounded-2xl shadow-lg max-w-md w-full p-8 text-center">
    <!-- Icono de éxito -->
    <div class="flex items-center justify-center w-20 h-20 mx-auto mb-6 bg-green-100 rounded-full">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-green-600" fill="none" viewBox="0 0 24 24"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>

    <!-- Título -->
    <h1 class="text-2xl font-semibold text-metro-blue-secondary mb-4">{{"::PaymentApproved" | abpLocalization}}</h1>

    <!-- Detalles de la orden -->
    <div class="text-left text-metro-blue  mb-6">
      <p><strong>{{"::Order" | abpLocalization}}:</strong> {{ orderId }}</p>
      <p><strong>{{"::TransactionId" | abpLocalization}}:</strong> {{ paymentTransactionId }}</p>
    </div>
  </div>
</div>

}


@if (status === 'transfer') {
<div class="flex flex-col items-center justify-center  bg-gray-50 p-4">
  <div class="
     bg-white rounded-2xl shadow-lg max-w-md w-full p-8 text-center
    ">
    <h1 class="text-2xl font-semibold text-metro-blue-secondary mb-4">{{"::OrderCreatedSuccessfully" |
      abpLocalization}}</h1>
    <div class="text-left mb-4 space-y-2">
      <div class="flex justify-between items-center">
        <span><strong>Cuenta:</strong> {{ bankInfo.account }}</span>
      </div>

      <div class="flex justify-between items-center">
        <span><strong>Alias:</strong> {{ bankInfo.alias }}</span>
        <button (click)="copyToClipboard(bankInfo.alias)" class="p-1 bg-gray-200 rounded hover:bg-gray-300">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-metro-blue-secondary" fill="none"
            viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h6a2 2 0 002-2v-6m-6 6H6a2 2 0 01-2-2v-6" />
          </svg>
        </button>
      </div>

      <div class="flex justify-between items-center">
        <span><strong>CBU:</strong> {{ bankInfo.cbu }}</span>
        <button (click)="copyToClipboard(bankInfo.cbu)" class="p-1 bg-gray-200 rounded hover:bg-gray-300">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5  text-metro-blue-secondary" fill="none"
            viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h6a2 2 0 002-2v-6m-6 6H6a2 2 0 01-2-2v-6" />
          </svg>
        </button>
      </div>
    </div>

    <div class="flex justify-center mt-4">
      <app-metro-button [fullWidth]="false" text="{{ '::Back' | abpLocalization }}" variant="primary" (click)="goToHome()"></app-metro-button>
    </div>
  </div>

</div>


}
